import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { content } from "./content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  const toggle = useCallback(() => {
    setLang((prev) => (prev === "en" ? "id" : "en"));
  }, []);

  const value = useMemo(() => ({
    lang,
    setLang,
    toggle,
    t: content[lang],
    other: lang === "en" ? "ID" : "EN",
  }), [lang, toggle]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
